import React from 'react'
import { Table, TableEmptyState, TablePagination } from 'components'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { getWalletPendingFunds, setTableConfiguration } from 'store/actions/wallet/wallet'
import PendingFundsTableRow from './PendingFundsTableRow'

const useStyles = makeStyles({
  table: {},
  tableHeaderCell: {},
})

const columns = [
  {
    value: 'paid_at',
    label: 'Posted',
  },
  {
    value: 'title',
    label: 'Item',
  },
  {
    value: 'revenue',
    label: 'Revenue',
    numeric: true,
  },
  {
    value: 'xira_charge',
    label: 'XIRA charge',
    numeric: true,
  },
  {
    value: 'transaction_charge',
    label: 'Transaction charge',
    numeric: true,
  },
  {
    value: 'pending_funds',
    label: 'Funds pending',
    numeric: true,
  },
  {
    value: 'available_date',
    label: 'Available',
  },
]

const PendingFundsTable = ({ setSelectedInvoiceId }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const walletItems = useSelector(state => state.wallet.walletPendingFunds)
  const count = useSelector(state => state.wallet.walletPendingFundsLength)
  const { limit, tablePage } = useSelector(state => state.wallet.tableConfiguration)
  const timezone = useSelector(state => state.calendar.advanced_calendar.timezone)

  const onRowsPerPageChange = value => {
    dispatch(
      setTableConfiguration({
        tablePage: 0,
        offset: 0,
        limit: value,
      })
    )
    dispatch(getWalletPendingFunds())
  }

  const onPageChange = value => {
    dispatch(
      setTableConfiguration({
        tablePage: value,
        offset: value * limit,
      })
    )
    dispatch(getWalletPendingFunds())
  }

  return !count ? (
    <TableEmptyState />
  ) : (
    <Table
      tableColumns={columns}
      className={classes.table}
      tableHeaderCellClass={{ root: classes.tableHeaderCell }}
      tableData={walletItems}
      tableDataRowRenderer={(columns, data) => (
        <PendingFundsTableRow
          columns={columns}
          data={data}
          setSelectedInvoiceId={setSelectedInvoiceId}
          timezone={timezone}
        />
      )}
      activeRows
      footer={
        <TablePagination
          page={tablePage}
          colSpan={columns.length}
          count={count}
          rowsPerPage={limit}
          onRowsPerPageChange={onRowsPerPageChange}
          onPageChange={onPageChange}
          rowsPerPageOptions={[50, 100, 200]}
        />
      }
    />
  )
}

export default PendingFundsTable
